import { createSlice } from '@reduxjs/toolkit'

export const tutorialData = createSlice({
    name: 'tutorialData',
    initialState: {
        allTutorials: [],
    },
    reducers: {
        setTutorialData: (state, data) => {
            const tutorialPayload = data.payload;
            state.allTutorials = tutorialPayload
        },
    },
})

export const { setTutorialData } = tutorialData.actions

export default tutorialData.reducer